import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export function TrackSearch({ initial = "", dark }) {
  const [value, setValue] = useState(initial);
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    const v = value.trim().toUpperCase();
    if (v) navigate(`/track/${encodeURIComponent(v)}`);
  };
  return (
    <form onSubmit={submit} className={`flex w-full gap-2 p-2 rounded-sm ${dark ? "bg-white/10 backdrop-blur-xl border border-white/20" : "bg-white border border-slate-200 shadow-sm"}`} data-testid="track-search-form">
      <div className="flex-1 flex items-center gap-3 bg-white rounded-sm px-4">
        <Search className="h-5 w-5 text-slate-400 shrink-0" />
        <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="Enter tracking number e.g. ISH-9842-7104"
          className="w-full h-12 outline-none font-mono text-sm sm:text-base text-[#0F172A] placeholder:text-slate-400 placeholder:font-sans bg-transparent" data-testid="track-search-input" />
      </div>
      <button type="submit" className="px-5 sm:px-8 h-14 sm:h-auto bg-[#FF6B00] hover:bg-[#E05D00] text-white font-semibold rounded-sm transition-colors" data-testid="track-search-submit">
        Track
      </button>
    </form>
  );
}
